export const tagTypes = {
  user: "user",
  auth: "auth",
  product: "product",
  order: "order",
};

export const tagTypesList = [
  tagTypes.user,
  tagTypes.product,
  tagTypes.auth,
  tagTypes.order,
];
